import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import * as React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { signUp } from "@/redux/slices/auth";
import "./index.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

export default function SignUpInputComponent() {
	const { t, i18n } = useTranslation();
	const [checked, setChecked] = React.useState(false);
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(event.target.checked);
	};
	const label = { inputProps: { "aria-label": "Checkbox demo" } };
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();
	const history = useHistory();
	const [validationSchema, setValidationSchema] = useState(
		yup.object({
			nameFirst: yup.string().trim().required("이름은 필수입니다"),
			nameLast: yup.string().trim().required("성은 필수입니다"),
			email: yup
				.string()
				.email("영문, 숫자, 마침표 그리고 @만 입력해주세요")
				.required("이메일은 필수입니다"),
			password: yup
				.string()
				.required("비밀번호는 필수입니다")
				.matches(
					/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$|^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$|^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/,
					"8~20자 사이, 영문(대소문자)+숫자+특수문자 중 2종류 이상을 조합하여 사용할 수 있습니다",
				),
		}),
	);
	useEffect(() => {
		if (i18n.language === "ko") {
			setValidationSchema(
				yup.object({
					nameFirst: yup.string().trim().required("이름은 필수입니다"),
					nameLast: yup.string().trim().required("성은 필수입니다"),
					email: yup
						.string()
						.email("영문, 숫자, 마침표 그리고 @만 입력해주세요")
						.required("이메일은 필수입니다"),
					password: yup
						.string()
						.required("비밀번호는 필수입니다")
						.matches(
							/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$|^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$|^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/,
							"8~20자 사이, 영문(대소문자)+숫자+특수문자 중 2종류 이상을 조합하여 사용할 수 있습니다",
						),
				}),
			);
		} else {
			setValidationSchema(
				yup.object({
					nameFirst: yup.string().trim().required("Please enter first name"),
					nameLast: yup.string().trim().required("Please enter last name"),
					email: yup
						.string()
						.email("Please enter only alphabets, numbers, periods, and @")
						.required("Please enter your email"),
					password: yup
						.string()
						.required("Please enter your password")
						.matches(
							/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$|^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$|^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/,
							"You can use 8 to 20 characters, combining at least two of the following: uppercase letters, lowercase letters, numbers, and special characters",
						),
				}),
			);
		}
	}, [i18n.language]);
	/* validationSchema = yup.object({
		nameFirst: yup.string().trim().required("이름은 필수입니다"),
		nameLast: yup.string().trim().required("성은 필수입니다"),
		email: yup
			.string()
			.email("영문, 숫자, 마침표 그리고 @만 입력해주세요")
			.required("이메일은 필수입니다"),
		password: yup
			.string()
			.required("비밀번호는 필수입니다")
			.matches(
				/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$|^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$|^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/,
				"8~20자 사이, 영문(대소문자)+숫자+특수문자 중 2종류 이상을 조합하여 사용할 수 있습니다",
			),
	}); */
	const formik = useFormik({
		initialValues: {
			nameFirst: "",
			nameLast: "",
			email: "",
			password: "",
		},
		validationSchema,
		onSubmit: (values) => {
			if (checked) {
				const requestData = {
					nameFirst: values.nameFirst,
					nameLast: values.nameLast,
					email: values.email,
					password: values.password,
					snsId: "",
					loginType: "email",
				};
				dispatch(
					signUp({
						requestData,
						callback: () => history.push("/"),
						enqueueSnackbar,
					}),
				);
			} else {
				enqueueSnackbar(t("marketing_agree_guide"), {
					variant: "info",
				});
			}
		},
	});
	return (
		<div
			style={{
				border: "1px solid #ccc",
				padding: "2.5rem",
				borderRadius: "10px",
			}}
		>
			<form onSubmit={formik.handleSubmit}>
				<Box
					sx={{
						maxWidth: "100%",
						marginBottom: "1rem",
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<div style={{ width: "49%" }}>
						<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
							{t("login.join_first_name")}
						</Typography>
						<TextField
							id="nameFirst"
							name="nameFirst"
							fullWidth={true}
							value={formik.values.nameFirst}
							onChange={formik.handleChange}
							error={
								formik.touched.nameFirst &&
								Boolean(formik.errors.nameFirst)
							}
							helperText={
								formik.touched.nameFirst && formik.errors.nameFirst
							}
						/>
					</div>
					<div style={{ width: "49%" }}>
						<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
							{t("login.join_last_name")}
						</Typography>
						<TextField
							id="nameLast"
							name="nameLast"
							fullWidth={true}
							value={formik.values.nameLast}
							onChange={formik.handleChange}
							error={
								formik.touched.nameLast && Boolean(formik.errors.nameLast)
							}
							helperText={formik.touched.nameLast && formik.errors.nameLast}
						/>
					</div>
				</Box>
				<Box
					sx={{
						maxWidth: "100%",
						marginBottom: "1rem",
					}}
				>
					<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
						{t("email")}
					</Typography>
					<TextField
						fullWidth={true}
						id="email"
						name="email"
						value={formik.values.email}
						onChange={formik.handleChange}
						error={formik.touched.email && Boolean(formik.errors.email)}
						helperText={formik.touched.email && formik.errors.email}
						sx={{ marginBottom: "1rem" }}
					/>
					<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
						{t("password")}
					</Typography>
					<TextField
						fullWidth
						id="password"
						name="password"
						type="password"
						value={formik.values.password}
						onChange={formik.handleChange}
						error={formik.touched.password && Boolean(formik.errors.password)}
						helperText={formik.touched.password && formik.errors.password}
					/>
				</Box>
				<div style={{ display: "flex", marginTop: "2rem", marginBottom: "2rem" }}>
					<Checkbox
						{...label}
						checked={checked}
						onChange={handleChange}
						inputProps={{ "aria-label": "controlled" }}
					/>
					<p className="spanTextColor">
						{i18n.language === "ko" && (
							<>
								나는 Foodlens 로부터 마케팅 정보를 받는 것에 대한 동의를
								포함하는 Foodlens의
								<a
									href="https://www.doinglab.com/ko/about/terms_of_services"
									target="_blank"
									rel="noreferrer"
									className="pointText"
								>
									{" "}
									이용약관&nbsp;
								</a>
								및&nbsp;
								<a
									href="https://www.doinglab.com/ko/about/privacy_policy"
									target="_blank"
									rel="noreferrer"
									className="pointText"
								>
									개인정보 취급방침
								</a>
								에 동의합니다.
							</>
						)}
						{i18n.language === "en" && (
							<>
								I agree to Foodlens'
								<a
									href="https://www.doinglab.com/en/about/terms_of_services"
									target="_blank"
									rel="noreferrer"
									className="pointText"
								>
									{" "}
									Terms of Use&nbsp;
								</a>
								and&nbsp;
								<a
									href="https://www.doinglab.com/en/about/privacy_policy"
									target="_blank"
									rel="noreferrer"
									className="pointText"
								>
									Privacy Policy
								</a>
								, including consent to receive marketing information from
								Foodlens.
							</>
						)}
					</p>
				</div>

				<Button
					variant="contained"
					sx={{
						backgroundColor: "#0071E3",
						height: "3.5rem",
						marginBottom: "2rem",
						fontWeight: "bold",
						fontSize: "1.2rem",
					}}
					type="submit"
					fullWidth={true}
				>
					{t("login.sign_up")}
				</Button>
			</form>
		</div>
	);
}
